export const CHALLENGES_ENABLED = false;
export const AREAS_OF_IMPROVEMENT_ENABLED = false;
export const TALENT_ORGANIZER_ENABLED = true;
export const SPLASH_NOTIFICATIONS_ENABLED = true;
export const TALENT_CONNECTOR_ENABLED = true;
export const RANKINGS_NAVIGATION_ENABLED = false;
export const RATINGS_ENABLED = false;
export const REVIEWS_ENABLED = true;
export const ENTERTAINER_METRICS_ENABLED = true;
export const KING_OF_DRAG_ENABLED = false;
export const NEXT_LEVEL_ENTERTAINER_MANAGEMENT_ENABLED = true;
export const IS_PRODUCER_ENABLED = true;
export const IS_REFER_AND_EARN_ENABLED = false;
